import { FormMapping } from '@app/utils/form-mapping/decorators/form-mapping';
import { FormMappingAttribute } from '@app/utils/form-mapping/decorators/form-mapping-attribute';
import { FormMappingModel } from '@app/utils/form-mapping/models/form-mapping-model';
import { FeatureStatus } from '@business/feature/interfaces/feature-status';
import { BasicFeatureForm } from '@business/feature/models/basic-feature-form';
import { Feature } from '@business/feature/models/feature-model';

@FormMapping()
export class BasicFeatureFormModel extends FormMappingModel implements BasicFeatureForm {
  @FormMappingAttribute({
    mergeFunction(o: Feature, value: boolean, attr: string) {
      o.status = value ? FeatureStatus.ACTIVE : FeatureStatus.INACTIVE;
    },
    parseFunction(value: string, o: Feature) {
      return o.status === FeatureStatus.ACTIVE;
    },
  })
  public active: boolean;
}
